import { createAction } from "@ngrx/store";

export const initializedWithNoToken = createAction(
  'App.InitializedWithNoToken'
);
